import { render, staticRenderFns } from "./WxUserinfoIndex.vue?vue&type=template&id=2bb6469b&scoped=true&"
import script from "./WxUserinfoIndex.vue?vue&type=script&lang=js&"
export * from "./WxUserinfoIndex.vue?vue&type=script&lang=js&"
import style0 from "./WxUserinfoIndex.vue?vue&type=style&index=0&id=2bb6469b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb6469b",
  null
  
)

export default component.exports